import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";
import {  Link  } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useSelector } from "react-redux";
// import { useHistory } from "react-router-dom/cjs/react-router-dom";
import './loginSignUpT1.css'
import {   clientAppUserOTPLogin} from "../../../store/actions/User";

import Loading from "../../Loading/Loading";;

const LoginWithOTPT1 = ()=>{

 const dispatch = useDispatch();
 const data = useSelector((state)=>state?.user?.user);

 const handleMouseEnter = () =>dispatch({
  type: "CURSOR",
  
  payload:true
});
const handleMouseLeave = () => dispatch({
  type: "CURSOR",
  
  payload:false
});
    const loginSignUpPopUp = useSelector((state)=>state?.app?.loginSignUpPopUp);
  

   const [loginPopUp , setLoginPopUp] =useState(true);
  const history = useHistory();
 
   
   const localToken= localStorage.getItem("profile");
   const token = useSelector((state)=>state?.user?.user?.token);
  
  
useEffect(() => {
     
    if(data?.token){
          
    // history.push('/login');
   
   } })
 const [loader , setLoader] =useState({status:false});
 const [OTPlogin, setOTPlogin] = useState({userEmail:''
 
});




/* Handle Signup Function */
const handleOTPlogin=(e)=>{
  e.preventDefault();
//console.log(signup)

setLoader({status:true});
  const user = dispatch(clientAppUserOTPLogin(OTPlogin));
  /* get response as Promise   */
  user.then(response => {
  
    if(response){
      dispatch({
        type: "LoginSignUpPopUp",
        
        payload:"validateOTP"
      })
    }else{
    alert("no response")

    }
    ;
   

/* resetting Login input Fields */

setOTPlogin({userEmail:''

})

setLoader({status:false});


//history.push('/dashboard/profile');


  }).catch(error => {
    
/* resetting Login input Fields */
setOTPlogin({userEmail:''

})
setLoader({status:false});
    console.error(error);
  });
 
  }

    return <>
    
{(token===localToken&&token&&localToken)?
  <>
<div className="outer-all ">
  
<div></div>
  <div className = {` outer-left `}  id="outer-left">
  
 
      
      </div>
    <div className="outer-right">
        <div className="content-topk">
          <h1> You Are Already logged In</h1>
        </div>
        <div className="outer-logged-in">

</div></div></div>
</>  :<>


{<Loading  Load={loader?.status}/>}
  <form onSubmit={handleOTPlogin} >{loginSignUpPopUp=="loginWithOTP"?<div onClick={() => dispatch({
    type: "LoginSignUpPopUp",
    
    payload:""
  })}  className="cm_theme1_login-signup-backgropj"></div>:""} <div  className="cm_theme1_login-signup-card"><div  className="blank"> </div>
  <div  className="cm_theme1_login-signup-card-outerj"><div  className="cm_theme1_login-signup-inner">
  <div  className="cm_theme1_blankRight cm_theme1_login-signup-right-signup">
    <div>   <div  className="flex-space-between">  <div  style={{width:"240px",padding:"15px",borderRadius:"15px",marginTop:"10px"}}><img style={{width:"100%"}}
               alt="logo" src="https://i.postimg.cc/7Zwy3WW9/Testprism_Logo.png"/> </div>
        
              </div>
              
        <h3  style={{textAlign:"center"}}>App Tag Line</h3>
        <div className="logo-box-shadow">
        <div className=""  style={{padding:'10px',color:"#222",fontSize:'22px',textAlign:"center"}}> Login Or SignUp With Ease   </div>
        <div  className=""  style={{padding:'10px',color:"#666",fontSize:'15px',textAlign:"center"}}>
        Login Or SignUp With Ease And Access Your Courses   . </div>
        
               <div > 
               <div className="cm_theme1_Login-bottom">
              {loginPopUp?<div  onMouseEnter={handleMouseEnter}
                                  onMouseLeave={handleMouseLeave} 
                                 onClick={() => dispatch({
                                   type: "LoginSignUpPopUp",
                                   
                                   payload:"signUp"
                                 })} className="cm_theme1_course-btn-green-two" style={{fontSize:"16px"}}>
                                  Sign Up Here
                                 </div>:<Link to="./signup">
                                   <div  onMouseEnter={handleMouseEnter}
                                  onMouseLeave={handleMouseLeave} className="cm_theme1_course-btn-green-two" style={{fontSize:"16px"}}>
                                  Sign Up Here
                                 </div> </Link>} {loginPopUp?<div
                        onClick={() => dispatch({
                          type: "LoginSignUpPopUp",
                          
                          payload:"login"
                        })} className="cm_theme1_course-btn-green" style={{fontSize:"16px"}}>
                         Login Here.
                        </div>:<Link to="./login">
                    <div className="ikcraft_course-btn-green" style={{fontSize:"16px"}}>
                   Login Here.
                  </div> </Link>}</div></div></div></div> 
    </div>  <div  className="cm_theme1_login-signup-left-signup ">
      <h1 style={{"textAlign":"center"}}> Login With OTP </h1>
      
 <div  className="cm_theme1_login-input-card" style={{marginTop:"50px"}}>
 <input className="cm_theme1_input-textbox" required placeholder="Email" type="text"
  name="user_email" value={OTPlogin.userEmail} 
  onChange={(e)=>setOTPlogin({...OTPlogin, userEmail : e.target.value})} />
   </div>
	  
   
   
    
   
     
   
	
	<div  className="cm_theme1_login-input-card">
   
  <button  className="cm_theme1_login-signup-button" type="submit" id="signupBtn">Send Login OTP To Email</button>

  <div className="cm_theme1_Signup-bottom" style={{margin:'15px',fontSize:'12px',marginBottom:'10px'}}>
    <div  style={{padding:'15px',fontSize:'15px',}} > Forgot Password?  </div>
    {loginSignUpPopUp=="loginWithOTP"? <div 
     onClick={() => dispatch({
      type: "LoginSignUpPopUp",
      
      payload:"resetPassword"
    })}  onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} style={{padding:'15px',cursor:"pointer",fontSize:'12px', fontWeight:'bold',marginBottom:'10px',color:'#996699'}}> 
    Click To Reset. </div> :
  <Link to="./resetPassword">
    <div   onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave} style={{padding:'15px',cursor:"pointer",fontSize:'12px', fontWeight:'bold',marginBottom:'10px',color:'#996699'}}> 
      Click To Reset. </div> </Link>}</div>
</div>
  <div> 
    
    
    
    
  </div>
 </div>
    
    
  </div></div><div></div></div>
   </form>
</>}
    </>

}
export default LoginWithOTPT1;